<template>
	<div v-if="lines != undefined">
		<h2 class="title">
			<span>{{ lines.title }}</span>
			<small>{{ lines.gid }}.{{ lines.eid }}</small>
		</h2>
		<div class="cnt-form">
			<div class="row">
				<div
					v-for="(input, index) in form"
					class="col-sm-6"
					:key="index"
				>
					<span
						><b>{{ input.campo | fixNumber }}</b
						>: {{ input.titulo | fixText }}</span
					><br />
					<input-sd2000
						:settings="input"
						v-model="input.value"
						@input="lines.status = 1"
					/>
				</div>
			</div>

			<!-- <pre>{{lines.status}}</pre> -->
		</div>
	</div>
</template>
<script>
	import inputSd2000 from './inputSd2000.vue';
	import { orderBy, padStart } from 'lodash';
	export default {
		props: ['lines'],
		components: { inputSd2000 },
		filters: {
			fixNumber(val) {
				if (val == undefined || val == null) return '...';
				return padStart(String(val), 3, '0');
			},
			fixText(val) {
				if (val == undefined || val == null) return '...';
				return String(val).replace(/([a-z]{1})([A-Z]{1})/g, ' $2');
			},
		},
		computed: {
			form() {
				return orderBy(this.lines.linhas, ['campo'], ['ASC']);
			},
		},
	};
</script>
<style scoped>
	.title {
		margin-top: 0px;
		border-bottom: 1px solid #f5f5f5;
		padding-bottom: 7px;
	}
	.title span {
		display: block;
		width: 100%;
		text-overflow: ellipsis;
		overflow: hidden;
		white-space: nowrap;
	}
	.title small {
		display: block;
		color: #cccccc;
		font-size: 13px;
	}
</style>



// WEBPACK FOOTER //
// src/components/sd2000/solicitacoes/mdExams/formLines.vue